import axiosWithToken from '@/api/axios'
import { adminBaseUrl } from '@/store'
import { postMethodConfig } from '@/api/axios'

const state = () => ({
  deliveryTerms: [],
  isLoading: false
})

const getters = {
  deliveryTerms: (state) => state.deliveryTerms,
  isLoading: (state) => state.isLoading
}

const mutations = {
  SET_DELIVERY_TERMS(state, payload) {
    state.deliveryTerms = payload
  },
  SET_LOADING(state, payload) {
    state.isLoading = payload
  }
}

const actions = {
  fetchDeliveryTerms({ commit, dispatch }) {
    commit('SET_LOADING', true)
    axiosWithToken
      .get('/api/dashboard/delivery_terms')
      .then((res) => {
        commit('SET_DELIVERY_TERMS', res.data.message)
      })
      .catch((err) => {
        console.error(err)
        dispatch('auth/requestAuthError', err, { root: true })
      })
      .finally(() => {
        commit('SET_LOADING', false)
      })
  },
  createDeliveryTerm({ dispatch }, { payload, vm }) {
    const data = new FormData()
    for (const key in payload) {
      data.append(key, payload[key])
    }
    vm.isLoading = true
    axiosWithToken
      .post(`${adminBaseUrl}/delivery_terms`, data, postMethodConfig)
      .then(() => {
        vm.$router.push('/admin/delivery-terms')
      })
      .catch((err) => {
        console.error(err)
        dispatch('auth/requestAuthError', err, { root: true })
      })
      .finally(() => {
        vm.isLoading = false
      })
  },
  deleteDeliveryTerm(_context, { id, vm }) {
    axiosWithToken
      .delete(`${adminBaseUrl}/delivery_terms/${id}`)
      .then(() => {
        vm.$emit('update')
      })
      .catch((err) => {
        console.error(err)
      })
  },
  fetchDeliveryTerm(_context, { id, vm }) {
    vm.isLoading = true
    axiosWithToken
      .get(`${adminBaseUrl}/delivery_terms/${id}`)
      .then((res) => {
        const message = res.data.message
        vm.editForm.cityEn = message.city_en
        vm.editForm.cityRu = message.city_ru
        vm.editForm.termEn = message.term_en
        vm.editForm.termRu = message.term_ru
        vm.editForm.minPrice = message.min_price
        vm.editForm.price = message.price
      })
      .catch((err) => {
        console.error(err)
      })
      .finally(() => {
        vm.isLoading = false
      })
  },
  updateDeliveryTerm(_context, { payload, id, vm }) {
    const data = new FormData()
    for (const key in payload) {
      data.append(key, payload[key])
    }
    data.append('_method', 'PUT')

    vm.isLoading = true
    axiosWithToken
      .post(`${adminBaseUrl}/delivery_terms/${id}`, data, postMethodConfig)
      .then(() => {
        vm.$refs['editDeliveryTermModal'].hide()
        vm.$emit('update')
      })
      .catch((err) => {
        console.error(err)
      })
      .finally(() => {
        vm.isLoading = false
      })
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
